import { render } from "./Nav.vue?vue&type=template&id=acc561b4&scoped=true&bindings={}"
import script from "./Nav.vue?vue&type=script&lang=ts"
export * from "./Nav.vue?vue&type=script&lang=ts"

import "./Nav.vue?vue&type=style&index=0&id=acc561b4&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-acc561b4"

export default script